
import "Screens_old/CourseBody/Student/Assets/CourseBodyStudentPage.sass";
import log from "loglevel";
import SuspenseSpinner from "./SuspenseSpinner";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import * as constants from "Constants";
import PageNotFound from "Screens1/Common/PageNotFound";
import GradeSubmission from "Screens_old/OtherLab/student/GradeSubmission";
import ViewSubmissions from "Screens1/Instructor/Course/Content/OtherLabs/Containers/ViewSubmissions";
import QuizSubmissionsV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/QuizSubmissionsV2";
import StudentSubmissionV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/StudentSubmissionV2";
import QuizPreviewV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/QuizPreviewV2";
import NavigationBar from "./NavigationBar";
import LeaderBoard from "./Course/Content/Programming/Instructor/LeaderBoard/LeaderBoard";
import LeaderBoardV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/LeaderBoardV2";
import { setupAxiosDefaults, setupAxiosInterceptors } from "services/httpService";
import ScrollToTop from "Components/ScrollTop";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import MobileInstructorView from "Screens1/Common/MobileInstructorView/MobileInstructorView";
// import { initializeStatistics } from "Utils/statistics/videoStats";

const Activation = React.lazy(() => import('Screens_old/Activation/Activation'));
const VerifyAccount = React.lazy(() => import("Screens1/Common/VerifyAccount/VerifyAccount"));
const AuthHandoff = React.lazy(() => import("Screens1/Common/AuthHandoff/AuthHandoff"));
const TermsOfService = React.lazy(() => import("Screens_old/Layout/FooterPage/Components/terms"));
const PrivacyPage = React.lazy(() => import("Screens_old/Layout/FooterPage/Components/Privacy"));
const ContactUs = React.lazy(() => import("Screens_old/Layout/FooterPage/Components/ContactUs"));
const Support = React.lazy(() => import("Screens_old/Layout/FooterPage/Components/Support"));

// routes
const LandingPage = React.lazy(() => import("Screens_old/LandingPage/Common/Components/LandingPage"));
const PublicCoursesPage = React.lazy(() => import("Screens1/Common/PublicCourses/Containers/PublicCoursesPage"));
const OverviewDashboardRoute = React.lazy(() => import("./Admin/AdminDashboard"));
const AppPerformanceDashboard = React.lazy(() => import("Navigation/Admin/AppPerformanceDashboard"));
const SubjectiveGrading = React.lazy(() => import("../Screens1/Instructor/Course/Content/Programming/Components/SubjectiveGrading/SubjectiveGrading"));
const StudentSubjectiveGrading = React.lazy(() => import("Screens1/Student/Course/Content/Programming/ComponentsNew/Subjectivegrading/SubjectiveGrading"));
// import CoursesListPage from "Screens1/Common/MyDashboard/Containers/CoursesListPage";
// import CoursesListInstructorPage from "Screens1/Instructor/MyDashboard/Containers/CoursesListInstructorPage";
// import CoursesListStudentPage from "Screens1/Student/MyDashboard/Containers/CoursesListStudentPage";

// import CourseBodyPage from "Screens_old/CourseBody/Common/Containers/CourseBodyPage";
// import CoursesListPage from "Screens1/Common/MyDashboard/Containers/CoursesListPage";

import LabSubmissions from "./Course/Content/Programming/Instructor/LabSubmissions/LabSubmissions";
import SubmissionsV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/SubmissionsV2";
import ActivitySubmissionsV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/ActivitySubmissionsV2";
import GradingV2 from "Screens1/Instructor/Course/Content/LabsV2/ComponentsNew/GradingV2";
import SubmitAs from "./Course/Content/Programming/Instructor/AllSubmissions/SubmitAs";

// import ProgrammingDetails from "Screens1/Student/Course/Content/Programming/ComponentsNew/ProgrammingDetails/ProgrammingDetails";
// import CourseBodyInstructorPage from "Screens_old/CourseBody/Instructor/Containers/CourseBodyInstructorPage";
// import CourseBodyStudentPage from "Screens_old/CourseBody/Student/Containers/CourseBodyStudentPage";
// import { bindActionCreators } from "redux";

import IssuesListContainer from "./Course/Content/Labs/Instructor/IssuesListContainer/IssuesListContainer";
import InstructorReply from "./Course/Content/Labs/Instructor/InstructorReply/InstructorReply";
import TrustEdgeLanding from "Screens_old/TrustEdgeLanding/TrustEdgeLanding";
import ProgramPage from "Screens_old/ProgramPage/ProgramPage";
import CoursePage from "Screens_old/CoursePage/CoursePage";
import FloatingApplyButton from "Components/FloatingApplyButton";

//import axios from "axios";
//import * as constants from "Constants";
// import { authCheckState } from "Store/UserInfo/Actions";
// import CourseEnroll from "Screens1/Student/CourseEnroll";
// import * as actions from "Store/Course/Student/Actions";

const ProgrammingActivitySubmissions = React.lazy(() => import("./Course/Content/Programming/Instructor/AllSubmissions/AllSubmissions"));
// Assets

const ProfilePage = React.lazy(() => import("Screens1/Common/ProfilePage"));

const LoginPage = React.lazy(() => import('Screens_old/Layout/Common/Components/LoginPage'));
const ForgotPassword = React.lazy(() => import('Screens1/Common/ForgotPassword'));
const ChangePassword = React.lazy(() => import('Screens1/Common/ChangePassword'));
// CourseNavigation loaded eagerly to prevent UI flicker during navigation
// This is a core component that's almost always needed when user accesses a course
import CourseNavigation from 'Navigation/Course';
const CoursesListInstructorPage = React.lazy(() => import('Screens1/Instructor/MyDashboard/Containers/CoursesListInstructorPage'));
const CoursesListStudentPage = React.lazy(() => import('Screens1/Student/MyDashboard/Containers/CoursesListStudentPage'));
const AppAuth = React.lazy(() => import('Screens1/Common/AppAuth'));
const CampaignUrlBuilder = React.lazy(() => import('analytics/components/CampaignUrlBuilder'));

import IframeNavigation from "./IframeNavigation";

import { authSuccess } from "Store/UserInfo/Actions";
import { Modal } from "react-bootstrap";
// import FullLoginPage from "Screens1/Common/LoginPage";

const Navigation = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [isMobile] = useState(() => window.innerWidth < 768);

  const token = useSelector((state) => state.userInfo.token);
  const mode = useSelector((state) => state.userInfo.mode);
  const isAuthenticated = token !== null;
  const { enableInstructorV2 } = useFeatureFlags();

  // Select leaderboard component based on feature flag
  const LeaderBoardComponent = enableInstructorV2 ? LeaderBoardV2 : LeaderBoard;
  // Select submissions component based on feature flag
  const LabSubmissionsComponent = enableInstructorV2 ? SubmissionsV2 : LabSubmissions;
  // Select activity submissions component based on feature flag
  const ActivitySubmissionsComponent = enableInstructorV2 ? ActivitySubmissionsV2 : ProgrammingActivitySubmissions;
  // Select quiz submissions component based on feature flag
  const QuizSubmissionsComponent = enableInstructorV2 ? QuizSubmissionsV2 : ViewSubmissions;
  // Select student submission component based on feature flag
  const StudentSubmissionComponent = enableInstructorV2 ? StudentSubmissionV2 : GradeSubmission;
  const [submissionData, setSubmissionData] = useState(null);
  const location = useLocation();

  const [axiosReady, setAxiosReady] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [modalReady, setModalReady] = useState(false);
  useEffect(() => {
    setupAxiosInterceptors(dispatch);
    const searchParams = new URLSearchParams(window.location.search);
    const passedToken = searchParams.get("setToken");
    const passedMode = searchParams.get("setMode") || "S";
    if (passedToken !== null) {
      const httpService = setupAxiosDefaults({
        baseURL: constants.base_url,
        headers: {
          Authorization: "Token " + passedToken,
        }
      });
      httpService.get("/accounts/whoami/").then(res => {
        const userState = {
          token: passedToken,
          username: res?.data?.username,
          email: res?.data?.email,
          userId: res?.data?.id,
          name: res?.data?.first_name + " " + res?.data?.last_name,
          mode: passedMode,
        }
        dispatch(authSuccess(userState));
      });
    }
    else if (token !== null) {
      setupAxiosDefaults({
        baseURL: constants.base_url,
        headers: {
          Authorization: "Token " + token,
        }
      });
    } else {
      setupAxiosDefaults({
        baseURL: constants.base_url,
        headers: {}
      });
    }
    setAxiosReady(true);
  }, [token]);

  useEffect(() => {
    setModalReady(true);
  }, []);


  const handleShowLogin = () => {
    log.log("Opening login modal from Navigation");
    if (modalReady && !showLoginModal) {
      setTimeout(() => {
        setShowLoginModal(true);
      }, 10);
    }
  };

  const handleHideLogin = () => {
    log.log("Closing login modal from Navigation");
    setShowLoginModal(false);
  };

  const LoginModal = () => {
    // if (!modalReady) return <></>;
    return (
      <Modal
        show={showLoginModal}
        onHide={handleHideLogin}
        dialogClassName="d-flex justify-content-center"
        centered
        contentClassName="w-dialog d-flex justify-content-center align-items-center user-select-none"
        backdrop={true}
        backdropClassName="login-modal-backdrop"
        animation={true}
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Body>
          <React.Suspense fallback={<SuspenseSpinner />}>
            <LoginPage isAuthenticated={isAuthenticated} handleHideLogin={handleHideLogin} />
          </React.Suspense>
        </Modal.Body>
      </Modal>

    )
  }

  const FullPageNavigation = () => {

    return (
      <>
        <NavigationBar handleShowLogin={handleShowLogin} handleHideLogin={handleHideLogin} />
        <Routes>
          <Route
            path="/"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                {/* <LandingPage isAuthenticated={isAuthenticated} /> */}
                {process.env.REACT_APP_MODE == "trustedge" ? (
                  <TrustEdgeLanding />
                ) : (
                  <LandingPage isAuthenticated={isAuthenticated} />
                )}
              </React.Suspense>
            }
          />

          <Route
            path="/program/:id"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                {process.env.REACT_APP_MODE == "trustedge" && <ProgramPage />}
              </React.Suspense>
            }
          />
          <Route
            path="/course/:id"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                {process.env.REACT_APP_MODE == "trustedge" && <CoursePage />}
              </React.Suspense>
            }
          />

          <Route
            path="/auth/handoff"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <AuthHandoff />
              </React.Suspense>
            }
          />
          <Route
            path="/login"
            element={isAuthenticated ? (<Navigate to="/courseware" />) : (
              <React.Suspense fallback={<SuspenseSpinner />}>
                <LoginPage isAuthenticated={isAuthenticated} />
              </React.Suspense>)
            }
          />

          <Route
            path="/courseware/courseslist"
            element={
              isAuthenticated ? (
                <React.Suspense fallback={<SuspenseSpinner />}>
                  <CoursesListStudentPage />
                </React.Suspense>
              ) : (
                <Navigate to="/login" />
              )
            } />




          <Route
            path="/resetpassword"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <ForgotPassword isAuthenticated={isAuthenticated} />
              </React.Suspense>
            }
          />

          {/* <Route
            path="/resetpassword"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <ForgotPassword isAuthenticated={isAuthenticated} />
              </React.Suspense>}
          /> */}

          <Route
            path="/accounts/changepassword/:key"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <ChangePassword isAuthenticated={isAuthenticated} />
              </React.Suspense>
            } />

          <Route
            path="/courseware"
            element={isAuthenticated ? (
              <React.Suspense fallback={<SuspenseSpinner />}>
                <PublicCoursesPage />
              </React.Suspense>
            ) : (
              <Navigate to="/login" />
            )} />

          <Route
            path="/profile"
            element={isAuthenticated ? (
              // <React.Suspense fallback={<SuspenseSpinner />}><PublicCoursesPage /></React.Suspense>
              <React.Suspense fallback={<SuspenseSpinner />}>
                <ProfilePage />
              </React.Suspense>
            ) : (
              <Navigate to="/login" />
            )} />

          <Route
            path="/courseware/course/:courseId/*"
            element={
              isAuthenticated ? (
                <CourseNavigation routeProps={params} />
              ) : (
                <Navigate to="/login" replace={true} />
              )
            }
          />
          <Route
            path="/courseware/course/:courseId/content/labs/:labId/programming/:activityId/SubjectiveGrading/:studentId"
            element={
              isAuthenticated ? (
                <React.Suspense fallback={<SuspenseSpinner />}>
                  <StudentSubjectiveGrading />
                </React.Suspense>
              ) : (
                <LoginPage isAuthenticated={isAuthenticated} />
              )
            }
          />
          <Route
            path="/terms"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <TermsOfService />
              </React.Suspense>
            }
          />
          <Route
            path="/privacy"
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <PrivacyPage />
              </React.Suspense>
            }
          />
          <Route
            path="/contactus"
            element={<React.Suspense fallback={<SuspenseSpinner />}>
              <ContactUs />
            </React.Suspense>
            }
          />
          <Route
            path="/support"
            element={<React.Suspense fallback={<SuspenseSpinner />}>
              <Support />
            </React.Suspense>
            }
          />
          <Route
            path="/campaigns"
            element={
              isAuthenticated ? (
                <React.Suspense fallback={<SuspenseSpinner />}>
                  <CampaignUrlBuilder />
                </React.Suspense>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/verify/:email_hash"
            element={<React.Suspense fallback={<SuspenseSpinner />}>
              <VerifyAccount />
            </React.Suspense>}
          />
          <Route
            path='/SubjectiveGrading/:type'
            element={
              <React.Suspense fallback={<SuspenseSpinner />}>
                <SubjectiveGrading
                  submissionData={submissionData}
                  setSubmissionData={setSubmissionData}
                />
              </React.Suspense>
            } />

          <Route path="/resetpassword" element={<React.Suspense fallback={<SuspenseSpinner />}>
            <ForgotPassword isAuthenticated={isAuthenticated} />
          </React.Suspense>} />


          <Route path="/courseware" element={isAuthenticated ? (
            // <React.Suspense fallback={<SuspenseSpinner />}><PublicCoursesPage /></React.Suspense>
            <PublicCoursesPage />
          ) : (
            <Navigate to="/login" />
          )} />


          <Route
            path="/courseware/course/:courseId/*"
            element={
              isAuthenticated ? (
                <CourseNavigation routeProps={params} />
              ) : (
                <Navigate to="/login" replace={true} />
              )
            }
          />

          <Route path="/app_auth" element={
            isAuthenticated ?
              <AppAuth /> :
              <Navigate to="/login" />
          } />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/support" element={<Support />} />
          <Route path="/verify/:email_hash" element={<VerifyAccount />} />
          <Route path='/SubjectiveGrading/:type' element=
            {enableInstructorV2 ? (
              <GradingV2
                submissionData={submissionData}
                setSubmissionData={setSubmissionData}
              />
            ) : (
              <SubjectiveGrading
                submissionData={submissionData}
                setSubmissionData={setSubmissionData}
              />
            )}
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>    
      </>
    );
  };

  if (!axiosReady) return <></>;



  switch (mode) {
    case "I":
      return (
        <>
          {/* <ToastContainer limit={1} hideProgressBar={true} /> */}
          <ScrollToTop />
          {!window.location.pathname.startsWith('/iframe') && <NavigationBar />}
          {isMobile ? (
            // Mobile Instructor View
            <MobileInstructorView title="Courses" />
          ) :
            (<Routes>
              <Route path="/iframe/*" element={<IframeNavigation />} />
              <Route
                path="/"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    {/* <LandingPage isAuthenticated={isAuthenticated} /> */}
                    {process.env.REACT_APP_MODE == "trustedge" ? (
                      <TrustEdgeLanding />
                    ) : (
                      <LandingPage isAuthenticated={isAuthenticated} />
                    )}

                  </React.Suspense>}
              />
              <Route
                path='/accounts/activate/:id'
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <Activation />
                  </React.Suspense>
                }
              />
              {/* <Route
              path="/homepage/:sno"
              render={(routeProps) => {
                log.log(routeProps);
                var html = routeProps.location.query;

                return React.createElement("div", {
                  dangerouslySetInnerHTML: { __html: html },
                });
              }}
            /> */}
              <Route
                path="/auth/handoff"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <AuthHandoff />
                  </React.Suspense>
                }
              />
              <Route
                path="/login"
                element={
                  isAuthenticated ? (
                    <Navigate to="/courseware/courseslist" />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              />
              <Route
                path="/resetpassword"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <ForgotPassword isAuthenticated={isAuthenticated} />
                  </React.Suspense>}
              />
              <Route
                path="accounts/changepassword/:key"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <ChangePassword isAuthenticated={isAuthenticated} />
                  </React.Suspense>
                }
              />
              <Route
                path={`/courseware/course/:courseId/content/labs/:labId/activities/other/:activityID/submissions`}
                element={isAuthenticated ? <QuizSubmissionsComponent /> : <Navigate to="/login" />}
              />

              <Route
                path={`/courseware/course/:courseId/content/labs/:labId/activities/other/:activityID/submissions/:studentID`}
                element={isAuthenticated ? <StudentSubmissionComponent /> : <Navigate to="/login" />}
              />

              <Route
                path={`/courseware/course/:courseId/content/labs/:labId/other/:activityID/preview`}
                element={isAuthenticated ? <QuizPreviewV2 /> : <Navigate to="/login" />}
              />

              <Route
                path="/program/:id"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    {process.env.REACT_APP_MODE == "trustedge" && <ProgramPage />}
                  </React.Suspense>
                }
              />

              <Route
                path="/course/:id"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    {process.env.REACT_APP_MODE == "trustedge" && <CoursePage />}
                  </React.Suspense>
                }
              />

              <Route
                path="/courseware"
                element={isAuthenticated ? (
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <PublicCoursesPage />
                  </React.Suspense>
                ) : (
                  <Navigate to="/login" />
                )}
              />
              <Route
                path="/courseware/courseslist"
                element={isAuthenticated ? (
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <CoursesListInstructorPage />
                  </React.Suspense>
                ) : (
                  <Navigate to="/login" />
                )}
              />

              <Route
                path="/courseware/course/:courseId/content/labs/:labId/programming/:activityID/submissions"
                element=
                {isAuthenticated ?
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <ActivitySubmissionsComponent
                      submissionData={submissionData}
                      setSubmissionData={setSubmissionData}
                    />
                  </React.Suspense>
                  :
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <LoginPage isAuthenticated={isAuthenticated} />
                  </React.Suspense>
                }
              />



              <Route
                path="/courseware/course/:courseId/content/lab/:labId/leaderboard"
                element={
                  isAuthenticated ? (
                    <LeaderBoardComponent />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              />

              <Route
                path="/courseware/course/:courseId/content/labs/:labId/programming/:activityId/submissions/SubjectiveGrading/:studentId"
                element={
                  isAuthenticated ? (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      {enableInstructorV2 ? (
                        <GradingV2
                          submissionData={submissionData}
                          setSubmissionData={setSubmissionData}
                        />
                      ) : (
                        <SubjectiveGrading
                          submissionData={submissionData}
                          setSubmissionData={setSubmissionData}
                        />
                      )}
                    </React.Suspense>
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              />


              <Route
                path="/courseware/course/:courseId/content/labs/:labId/submissions"
                element={
                  isAuthenticated ? (
                    <LabSubmissionsComponent />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                } />



              < Route
                path="/courseware/course/:courseId/*"
                element={
                  isAuthenticated ?
                    <CourseNavigation />
                    :
                    <Navigate to="/login" />
                }
              />


              < Route
                path="/courseware/course/:courseId/content/labs/:labId/issues"
                element={
                  isAuthenticated ? (
                    <IssuesListContainer />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              />

              < Route
                path="/courseware/course/:courseId/content/labs/:labId/issues/:issueId/reply"
                element={
                  isAuthenticated ? (
                    <InstructorReply />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              ></Route >

              <Route
                path="/courseware/course/:courseId/content/labs/:labId/programming/:activityId/submissions/SubjectiveGrading/:type"
                element={
                  isAuthenticated ? (
                    enableInstructorV2 ? (
                      <GradingV2
                        submissionData={submissionData}
                        setSubmissionData={setSubmissionData}
                      />
                    ) : (
                      <SubjectiveGrading
                        submissionData={submissionData}
                        setSubmissionData={setSubmissionData}
                      />
                    )
                  ) :
                    <Navigate to="/login" />
                }
              />
              <Route
                path="/overviewdashboard"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <OverviewDashboardRoute isAuthenticated={isAuthenticated} />
                  </React.Suspense>}
              />
              <Route
                path="/performance-dashboard"
                element={isAuthenticated ?
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <AppPerformanceDashboard />
                  </React.Suspense>
                  : <Navigate to='/login' />
                }
              />




              <Route
                path="/courseware/course/:courseId/content/labs/:labId/programming/:activityId/submissions/:studentID/submitas"
                element={
                  isAuthenticated ? (
                    <SubmitAs />
                  ) : (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <LoginPage isAuthenticated={isAuthenticated} />
                    </React.Suspense>
                  )
                }
              />

              <Route
                path="/courseware/course/:courseId/*"
                element={isAuthenticated ?
                  <CourseNavigation />
                  : <Navigate to="/login" />
                }
              />
              <Route
                path="/overviewdashboard"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <OverviewDashboardRoute isAuthenticated={isAuthenticated} />
                  </React.Suspense>}
              />
              <Route
                path="/performance-dashboard"
                element={isAuthenticated ?
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <AppPerformanceDashboard />
                  </React.Suspense>
                  : <Navigate to='/login' />
                }
              />


              {/* <Route
              {/* <Route
              path="/performance-dashboard"
              render={(routeProps) => {
                log.log(routeProps);
                if (isAuthenticated) {
                  return (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <AppPerformanceDashboard />
                    </React.Suspense>
                  )
                } else {
                  <Navigate to="/login" />;
                }
              }}
            /> */}

              <Route
                path="/profile"
                element={isAuthenticated ? (
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <ProfilePage />
                  </React.Suspense>
                ) : (
                  <Navigate to="/login" />
                )} />
              <Route
                path="/terms"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <TermsOfService />
                  </React.Suspense>
                } />
              <Route
                path="/privacy"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <PrivacyPage />
                  </React.Suspense>
                } />
              <Route
                path="/contactus"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <ContactUs />
                  </React.Suspense>
                } />
              <Route
                path="/support"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <Support />
                  </React.Suspense>
                } />
              <Route
                path="/campaigns"
                element={
                  isAuthenticated ? (
                    <React.Suspense fallback={<SuspenseSpinner />}>
                      <CampaignUrlBuilder />
                    </React.Suspense>
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
              <Route
                path="/verify/:email_hash"
                element={
                  <React.Suspense fallback={<SuspenseSpinner />}>
                    <VerifyAccount />
                  </React.Suspense>}
              />
              <Route path="/app_auth" element={
                isAuthenticated ?
                  <AppAuth /> :
                  <Navigate to="/login" />
              } />
              <Route
                path="*"
                element={<PageNotFound />}
              />
            </Routes>)}
        </>
      );

    default:
      return (
        <>
          <Routes>
            <Route path="/iframe/*" element={<IframeNavigation />} />
            <Route path="/*" element={<FullPageNavigation />} />
          </Routes>
          {!isAuthenticated && <FloatingApplyButton />}
          <LoginModal />
        </>
      );
  }
};

export default Navigation;
